import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    h1: {
      fontSize: { lg: '44px', md: '40px', base: '28px' },
      fontFamily: 'FedraSansStd-A-medium',
    },
    eligibilityText: {
      fontFamily: isIndian ? config.isoLangFont[lang] : 'FedraSansStd-book',
      textAlign: 'center',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      color: '#000',
    },
    tabText: {
      fontFamily: isIndian ? config.isoLangFont[lang] : 'FedraSansStd-book',
    },
    h4: {
      color: '#000',
      fontSize: { base: '20px', md: '28px' },
      fontFamily: isIndian ? config.isoLangFont[lang] : 'FedraSansStd-A-medium',
      // fontWeight: 'bold',
    },
    cardInfo2Text: {
      fontFamily: isIndian ? config.isoLangFont[lang] : 'FedraSansStd-book',
      // fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22.68px',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const SadhanaContentSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ lang: 'te' }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({ lang: 'ta' }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default SadhanaContentSt;
